import React from 'react'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'

import {ArrowBackSharp, ArrowForwardSharp} from '@mui/icons-material'
import {Theme} from '@mui/material'
import {PGButton, getProductLineColors} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

import {useProductLine} from '@progyny/hooks/useProductLine'
import {useRTL} from '@progyny/hooks/useRTL'

const useStyles = makeStyles<{color: string | undefined}>()(
  (theme: Theme, {color}) => ({
    backButton: {
      paddingLeft: 0,
      color: color,
      '&:hover': {
        color: color,
      },
    },
  })
)

type BackButtonProps = {
  onBackClick?: () => void
  text?: string
  color?: string
  style?: React.CSSProperties
}

const BackButton: React.ComponentType<BackButtonProps> = (props) => {
  const history = useHistory()
  const {t} = useTranslation()
  const {productLine} = useProductLine()
  const colors = getProductLineColors(productLine)
  const {isRTL} = useRTL()
  const defaultText = t('common_back')
  const {
    onBackClick,
    text,
    color = colors.primary,
    style,
    ...buttonProps
  } = props
  const {classes} = useStyles({color})

  const handleClick = onBackClick || history.goBack

  return (
    <PGButton
      disableRipple
      variant='text'
      startIcon={
        isRTL ? (
          <ArrowForwardSharp sx={{color}} />
        ) : (
          <ArrowBackSharp sx={{color}} />
        )
      }
      onClick={handleClick}
      className={classes.backButton}
      style={style}
      aria-label={text || defaultText}
      {...buttonProps}
      label={text || defaultText}
    />
  )
}

export default BackButton
